export const ALIASES_DOCUMENTO_ORDEM = [
  "pdf_orcamento_lifegrowth",
  "pdf_pedido_lifegrowth",
  "pdf_carrinho_commerce",
  "pdf_pedido_commerce"
];

export const WHERE_USED_BY_ALIAS = {
  pdf_orcamento_lifegrowth:
    "LifeGrowth — exportação de orçamento comercial (format=pdf).",
  pdf_pedido_lifegrowth:
    "LifeGrowth — exportação de pedido de venda (format=pdf).",
  pdf_carrinho_commerce:
    "Superon Commerce — exportação de carrinho (API orders/export).",
  pdf_pedido_commerce:
    "Superon Commerce — exportação de pedido aberto (sem layout=detalhe)."
};

export const TIPO_VARIAVEL_LABEL = {
  texto: "Texto",
  moeda: "Moeda",
  data: "Data",
  imagem_url: "Imagem (URL)",
  array_tabela: "Tabela (array)",
  coluna: "Coluna"
};

export function formatVariavelToken(chave) {
  if (!chave) return "";
  return `{{${chave}}}`;
}

/**
 * Insere token no cursor de um textarea nativo.
 * @returns {{ value: string, selectionStart: number, selectionEnd: number } | null}
 */
export function insertTokenAtCursor(textarea, token) {
  if (!textarea || typeof token !== "string") {
    return null;
  }
  const start =
    typeof textarea.selectionStart === "number" ? textarea.selectionStart : 0;
  const end =
    typeof textarea.selectionEnd === "number" ? textarea.selectionEnd : start;
  const value = textarea.value || "";
  const next = value.substring(0, start) + token + value.substring(end);
  const cursor = start + token.length;
  return {
    value: next,
    selectionStart: cursor,
    selectionEnd: cursor
  };
}

export function agruparVariaveisPorCategoria(variaveis) {
  if (!variaveis || typeof variaveis !== "object") {
    return [];
  }
  const grupos = {};
  Object.keys(variaveis).forEach(chave => {
    const meta = variaveis[chave] || {};
    const categoria = meta.categoria || "Geral";
    if (!grupos[categoria]) {
      grupos[categoria] = [];
    }
    const colunasCatalogo =
      meta.tipo === "array_tabela" && Array.isArray(meta.colunas)
        ? meta.colunas
        : [];
    const colunas = colunasCatalogo
      .filter(coluna => coluna && coluna.chave)
      .map(coluna => {
        const label = coluna.label || coluna.chave;
        return {
          chave: `${chave}.${coluna.chave}`,
          label,
          tipo: "coluna",
          descricao: coluna.opcional ? `${label} (opcional)` : label
        };
      });
    grupos[categoria].push({
      chave,
      label: meta.label || chave,
      tipo: meta.tipo || "texto",
      descricao: meta.descricao || "",
      colunas
    });
  });
  return Object.keys(grupos)
    .sort((a, b) => a.localeCompare(b, "pt-BR"))
    .map(categoria => ({
      categoria,
      itens: grupos[categoria]
        .sort((a, b) => a.label.localeCompare(b.label, "pt-BR"))
        .reduce((acc, item) => {
          const colunas = item.colunas || [];
          acc.push({
            chave: item.chave,
            label: item.label,
            tipo: item.tipo,
            descricao: item.descricao
          });
          colunas.forEach(coluna => acc.push(coluna));
          return acc;
        }, [])
    }));
}

export function montarOpcoesDocumento(listagem) {
  const byAlias = {};
  (listagem || []).forEach(item => {
    if (item && item.alias_documento) {
      byAlias[item.alias_documento] = item;
    }
  });
  return ALIASES_DOCUMENTO_ORDEM.filter(alias => byAlias[alias]).map(alias => ({
    value: alias,
    text: byAlias[alias].nome_exibicao || alias,
    personalizado: !!byAlias[alias].personalizado
  }));
}
